var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-2 main-card",attrs:{"outlined":""}},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("Stranica ne postoji.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }